import React from 'react';
import {Images,TextArea,Page} from '../index';
import {Btn} from '../../Common/index';
import styled from 'styled-components';
import comic1 from '../../../asset/img/comic/other/comic10_1.png';
import comic2 from '../../../asset/img/comic/other/comic10_2.png';

const H2 = styled.h2`
 font-size: 2em;
 `

const Story14
 = () => {
    return(
      <div className="common__item">
      <div className="common__center">
  <H2>伊東ヨシスケの船旅</H2>
  <Images 
  image_1= {comic1}
  image_2= {comic2}
  style3= "display-none"
   alt_1= "伊東ヨシスケの船旅"
   alt_2= "伊東ヨシスケの船旅"

  />
  <TextArea 
   text1="「耳川の戦い」のきっかけを作った張本人の「伊東」さんは大友家の敗戦後いじめられてしまいます。"
   text2="そんな「伊東さん」は「大友家」を去り堺(大阪)に向けて出航‥"
   text3="戦後時代史上、人生後半がハードモードの伊東さんはいかに‥"
   data="2018/07-07"
  />
  <Btn
   text="一覧に戻る"
   link="/comic"
  />
 </div>
 </div>
    )
}
export default Story14;